import { render } from "./tmr.vue?vue&type=template&id=7633ad98&scoped=true"
import script from "./tmr.vue?vue&type=script&lang=js"
export * from "./tmr.vue?vue&type=script&lang=js"

import "./tmr.vue?vue&type=style&index=0&id=7633ad98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7633ad98"]])

export default __exports__